let _store

const showOfflineMessage = () => {
  _store.dispatch('snackbar/showSnack', 'Verifique sua conexão com a internet')
  _store.dispatch('network/setOffline')
}

const hideOfflineMessage = () => {
  _store.dispatch('snackbar/hideSnack')
  _store.dispatch('network/setOnline')
}

export const initConnectionEventListener = (store) => {
  _store = store

  window.addEventListener('offline', showOfflineMessage)

  window.addEventListener('online', hideOfflineMessage)

  if (!navigator.onLine) {
    showOfflineMessage()
  }
}
